<template lang="pug">
  .b-change
    ._text Изменение участников
    UsersTile.old(v-if="removedUsers.length" :users="removedUsers" :headSize="3" :size="32")
    UsersTile(v-if="addedUsers.length" :users="addedUsers" :headSize="3" :size="32")
</template>

<script>
import UsersTile from '@/components/UsersTile.vue';
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'TaskChangeMembers',
  components: { UserAvatar, UsersTile },
  props: {
    change: Object,
  },
  computed: {
    removedUsers() { return this.change.info.removed.map((id) => this.change.users.find((u) => u.id === id)); },
    addedUsers() { return this.change.info.added.map((id) => this.change.users.find((u) => u.id === id)); },
  },
};
</script>

<style scoped lang="scss">
  .change {
    display: flex;
    align-items: center;
    column-gap: 30px;

    &__text {
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.01em;
      color: #1E3147;
      opacity: 0.5;
    }
  }
</style>
